import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { BackButton } from "../Buttons/BackButton";
import { Hamburger } from "../Buttons/Hamburger";
import { BrandingIcon } from "../Icons/BrandingIcon";
import { DocumentsIcon } from "../Icons/DocumentsIcon";
import { FavouriteIcon } from "../Icons/FavouriteIcon";
import { LanguagesIcon } from "../Icons/LanguagesIcon";
import { MetaDataIcon } from "../Icons/MetaDataIcon";
import { MetaDataTranslateIcon } from "../Icons/MetaDataTranslateIcon";
import { PortalSettingsIcon } from "../Icons/PortalSettingsIcon";
import { ReaderIcon } from "../Icons/ReaderIcon";
import { RecentFilesIcon } from "../Icons/RecentFilesIcon";
import { SearchIcon } from "../Icons/SearchIcon";
import { StartIcon } from "../Icons/StartIcon";
import { SynchronisationIcon } from "../Icons/SynchronisationIcon";
import { UserIcon } from "../Icons/UserIcon";
import { AppStore } from "../Stores/AppStore";
import { Strings } from "../Stores/StringsStore";
import { Urls } from "../Urls";
import { Link } from "./Link";

@observer
export class AppNavigation extends React.Component<{}, {}> {
	@observable on: boolean;

	toggle = () => {
		this.on = !this.on;
	}

	toggleOff = () => {
		this.on = false;
	}

	handleFavouriteClick = () => {
		this.on = false;
	}


	handleBack = () => {
		this.toggleOff();
		AppStore.goBack();
		AppStore.savePath(AppStore.history.location.pathname);
	}

	getClassName(path: string) {
		let currentPath = AppStore.previousPaths.length > 0 ? AppStore.previousPaths[AppStore.previousPaths.length - 1] : AppStore.history.location.pathname;
		let isPath: boolean;
		if (path === Urls.home) {
			isPath = currentPath === path;
		}
		else {
			isPath = currentPath.indexOf(path) > -1;
		}
		return isPath ? "current" : "";
	}

	render() {
		var className = !this.on ? "app-nav" : "app-nav is--app-nav-open";

		var docManager = AppStore.context.sessionDetails.isDocumentManager && !AppStore.context.sessionDetails.isApp ? <ul>
			<li className={this.getClassName(Urls.collections)}>
				<Link to={Urls.collections} onClick={this.toggleOff} useHistoryOverride={true} testId="navCollectionsLink" disabled={!AppStore.isSystemOnline}>
					<DocumentsIcon />
					<span>{Strings.appNavigation.collectionsLinkText}</span>
				</Link>
			</li>
		</ul> : null;

		var metaManager = AppStore.context.sessionDetails.isMetaDataManager && !AppStore.context.sessionDetails.isApp ? <ul>
			<li className={this.getClassName(Urls.metas)}>
				<Link to={Urls.metas} onClick={this.toggleOff} useHistoryOverride={true} testId="navMetaDataLink" disabled={!AppStore.isSystemOnline}>
					<MetaDataIcon />
					<span>{Strings.appNavigation.metaDataLinkText}</span>
				</Link>
			</li>
		</ul> : null;

		var brandingManager = AppStore.context.sessionDetails.isBrandingManager && !AppStore.context.sessionDetails.isApp ? <ul>
			<li className={this.getClassName(Urls.branding)}>
				<Link to={Urls.branding} onClick={this.toggleOff} useHistoryOverride={true} testId="navBrandingLink" disabled={!AppStore.isSystemOnline}>
					<BrandingIcon />
					<span>{Strings.appNavigation.brandingSettingsLinkText}</span>
				</Link>
			</li>
			<li className={this.getClassName(Urls.languages)}>
				<Link to={Urls.languages} onClick={this.toggleOff} useHistoryOverride={true} testId="navLanguagesLink" disabled={!AppStore.isSystemOnline}>
					<LanguagesIcon />
					<span>{Strings.appNavigation.languageSettingsLinkText}</span>
				</Link>
			</li>
		</ul> : null;

		var userManager = AppStore.context.sessionDetails.isUserManager && !AppStore.context.sessionDetails.isApp ? <ul>
			<li className={this.getClassName(Urls.userManagement)}>
				<a href={Urls.userManagement} data-test-id="navUserLink" target="_blank">
					<UserIcon />
					<span>{Strings.appNavigation.userLinkText}</span>
				</a>
			</li>
		</ul> : null;

		var client = AppStore.context.sessionDetails.isApp ? <ul>
			<li className={this.getClassName(Urls.portals)}>
				<Link to={Urls.portals} onClick={this.toggleOff} useHistoryOverride={true}>
					<PortalSettingsIcon />
					<span>{Strings.appNavigation.portalSettingsLinkText} {AppStore.context.sessionDetails.portalSettingsName !== "" ? " (" + AppStore.context.sessionDetails.portalSettingsName + ")" : ""}</span>
				</Link>
			</li>
		</ul> : null;

		var translation = AppStore.context.sessionDetails.isMetaDataManager && !AppStore.context.sessionDetails.isApp ? <ul>
			<li className={this.getClassName(Urls.translation)}>
				<Link to={Urls.translation} onClick={this.toggleOff} useHistoryOverride={true} testId="navTranslationLink" disabled={!AppStore.isSystemOnline}>
					<MetaDataTranslateIcon />
					<span>{Strings.appNavigation.translationLinkText}</span>
				</Link>
			</li>
		</ul> : null;


		return <div className={className} onMouseLeave={this.toggleOff}>

			<div className="app-nav__buttons">
				<Hamburger onClick={this.toggle} testId="navigationButton" />
				<BackButton onClick={this.handleBack} disabled={(AppStore.previousPaths.length === 0)} testId="backButton" />
			</div>

			<div className="app-nav__wrapper">

				<span className="app-nav__primary">
					<ul>
						<li className={this.getClassName(Urls.home)}>
							<Link to={Urls.home} onClick={this.toggleOff} useHistoryOverride={true} testId="navHomeLink">
								<StartIcon />
								<span data-test-id="navHomeCaption" data-test-name={Strings.appNavigation.homeLinkText}>{Strings.appNavigation.homeLinkText}</span>
							</Link>
						</li>
						<li className={this.getClassName(Urls.search)}>
							<Link to={Urls.search} onClick={this.toggleOff} useHistoryOverride={true} testId="navReaderLink">
								<SearchIcon />
								<span data-test-id="navSearchCaption" data-test-name={Strings.appNavigation.searchDocumentsLinkText}>{Strings.appNavigation.searchDocumentsLinkText}</span>
							</Link>
						</li>
						<li className={this.getClassName(Urls.reader)}>
							<Link to={Urls.reader} onClick={this.toggleOff} useHistoryOverride={true} testId="navReaderLink">
								<ReaderIcon />
								<span data-test-id="navReaderCaption" data-test-name={Strings.appNavigation.readerLinkText}>{Strings.appNavigation.readerLinkText}</span>
							</Link>
						</li>
						<li className={this.getClassName(Urls.favorites)}>
							<Link to={Urls.favorites} onClick={this.handleFavouriteClick} useHistoryOverride={true} testId="navFavoritesLink">
								<FavouriteIcon />
								<span data-test-id="navFavoritesCaption" data-test-name={Strings.appNavigation.favoriteLinkText}>{Strings.appNavigation.favoriteLinkText}</span>
							</Link>
						</li>
						<li className={this.getClassName(Urls.recentFiles)}>
							<Link to={Urls.recentFiles} onClick={this.toggleOff} useHistoryOverride={true} testId="navRecentFilesLink">
								<RecentFilesIcon />
								<span>{Strings.appNavigation.recentFilesLinkText}</span>
							</Link>
						</li>
						{AppStore.context.sessionDetails.isApp ? <li className={this.getClassName(Urls.sync)}>
							<Link to={Urls.sync} onClick={this.toggleOff} useHistoryOverride={true}>
								<SynchronisationIcon />
								<span>{Strings.appNavigation.syncLinkText}</span>
							</Link>
						</li> : null}
					</ul>
				</span>

				<span className="app-nav__secondary">
					{docManager}

					{metaManager}

					{translation}

					{userManager}

					{brandingManager}

					{client}
				</span>
			</div>

		</div>;
	}

}